import { Component } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
@Component({
  selector: 'app-applied-jobs',
  templateUrl: './applied-jobs.component.html',
  styleUrl: './applied-jobs.component.scss'
})
export class AppliedJobsComponent {
  appliedJobs: any[] = []; // Holds the list of applied jobs
  isLoading: boolean = true;


  constructor(private apiService: ApiService) {} // Inject ApiService

  ngOnInit(): void {
    this.fetchAppliedJobs();
     this.fetchAppliedJobs();
  }

  fetchAppliedJobs(): void {
    this.isLoading = true;
    this.apiService.getAppliedJobs().subscribe({
      next: (jobs) => {
        this.appliedJobs = jobs; // Assign fetched jobs
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching applied jobs:', error);
        this.isLoading = false;
      }
    });
  }

  deleteApplication(jobId: string) {
    this.apiService.deleteApplication(jobId).subscribe({
      next: () => {
        this.fetchAppliedJobs(); // Refetching for simplicity
      },
      error: (error) => console.error('Error deleting application:', error)
    });
  }
}
